@if(wizardStore.D().form; as formGroup){
  @if (stepDisabled()) {
    <div class="step-disabled-notification">
      <span class="step-disabled-notification__icon fas fa-info-circle" aria-hidden="true"></span>
      <span class="step-disabled-notification__text">{{ "projectWizard.stepDisabledForLoanPurpose" | translate }}</span>
    </div>
  }
<form [formGroup]="formGroup">
  <app-card [titleKey]="translationKey + 'formTitle'">
    <app-validated-number-input
      [label]="translationKey + 'totalAmount'"
      inputFormControlName="totalAmount"
      [inputFormControl]="formGroup.controls.totalAmount"
    />
    <app-validated-dropdown
      [label]="translationKey + 'typeLabel'"
      inputFormControlName="totalAmountType"
      [inputFormControl]="formGroup.controls.totalAmountType"
      [disabled]="stepDisabled()"
      [optionsStamp]="genericProjectStore.securitiesTypeEntities().length"
    >
      @for (securitiesType of genericProjectStore.securitiesTypeEntities();
      track $index) {
      <option [value]="securitiesType.id">
        {{ securitiesType.name | translate }}
      </option>
      }
    </app-validated-dropdown>

    <app-validated-number-input
      [label]="'general.bookingPrice'"
      inputFormControlName="bookingPrice"
      [inputFormControl]="formGroup.controls.bookingPrice"
    />
    <app-validated-dropdown
      [label]="'general.overBookingAcceptence'"
      inputFormControlName="overBookingAcceptence"
      [inputFormControl]="formGroup.controls.overBookingAcceptence"
      [disabled]="stepDisabled()"
    >
      <option [value]="true">{{ "general.yes" | translate }}</option>
      <option [value]="false">{{ "general.no" | translate }}</option>
    </app-validated-dropdown>

    <app-validated-dropdown
      [label]="translationKey + 'oversubscriptionAllocationType'"
      inputFormControlName="overbookingType"
      [inputFormControl]="formGroup.controls.overbookingType"
      [disabled]="stepDisabled()"
      [optionsStamp]="genericProjectStore.overSubscriptionTypeEntities().length"
    >
      @for (oversubscriptionType of
      genericProjectStore.overSubscriptionTypeEntities(); track $index) {
      <option [value]="oversubscriptionType.id">
        {{ oversubscriptionType.name | translate }}
      </option>
      }
    </app-validated-dropdown>

    <app-info-label [label]="translationKey + 'formInfoSubscription'" />
    <app-info-label [label]="translationKey + 'formInfoSafekeeping'" />

    <app-validated-dropdown
      [label]="translationKey + 'guarantorIsLegalPerson'"
      inputFormControlName="guarantorIsLegalPerson"
      [inputFormControl]="formGroup.controls.guarantorIsLegalPerson"
      [disabled]="stepDisabled()"
    >
      <option [value]="true">{{ "general.yes" | translate }}</option>
      <option [value]="false">{{ "general.no" | translate }}</option>
    </app-validated-dropdown>

    <app-validated-dropdown
      [label]="translationKey + 'covered'"
      inputFormControlName="covered"
      [inputFormControl]="formGroup.controls.covered"
      [disabled]="stepDisabled()"
    >
      <option [value]="true">{{ "general.yes" | translate }}</option>
      <option [value]="false">{{ "general.no" | translate }}</option>
    </app-validated-dropdown>
    <hr />
    <div>
      <label class="section-title">{{
        translationKey + "guarantorDetails" | translate
      }}</label>
    </div>

    <app-form-array-card
      [title]="translationKey + 'guarantor'"
      [formArray]="formGroup.controls.guarantors"
      [addButtonTitle]="translationKey + 'addPerson'"
      [disabled]="stepDisabled()"
      (add)="addGuarantor()"
      (remove)="removeGuarantor($event)"
    >
      <ng-template let-formGroup>
        <app-person-contact-form
          [formGroup]="formGroup"
          [title]="translationKey + 'guarantor'"
          [disabled]="stepDisabled()"
        />
      </ng-template>
    </app-form-array-card>

    <hr />
    <app-validated-textarea
      [label]="translationKey + 'guarantorInfo'"
      inputFormControlName="guarantorInfo"
      [inputFormControl]="formGroup.controls.guarantorInfo"
      [rows]="10"
      [maxLength]="2000"
    />
    <hr />
    <div class="row flex-between-center">
      <label>{{ translationKey + "commitmentAndDeadline" | translate }}</label>
      <div class="col-6 my-2">
        <app-validated-dropdown
          [label]="''"
          inputFormControlName="transferableSecurities"
          [inputFormControl]="formGroup.controls.transferableSecurities"
          [disabled]="stepDisabled()"
        >
          <option [value]="true">{{ "general.yes" | translate }}</option>
          <option [value]="false">{{ "general.no" | translate }}</option>
        </app-validated-dropdown>
      </div>
      <div class="col-6 my-2">
        <app-validated-date-picker
          [label]="''"
          inputFormControlName="transferableSecuritiesDate"
          [inputFormControl]="formGroup.controls.transferableSecuritiesDate"
          [disabled]="stepDisabled()"
        />
      </div>
    </div>
    <hr />
    <div>
      <label class="section-title">{{
        translationKey + "instruments" | translate
      }}</label>
    </div>
    <app-form-array-card
      [title]="translationKey + 'instrumentItem'"
      [formArray]="formGroup.controls.devices"
      [addButtonTitle]="translationKey + 'addInstrument'"
      [disabled]="stepDisabled()"
      (add)="addDevice()"
      (remove)="removeDevice($event)"
    >
      <ng-template let-formGroup>
        <app-device-card
          [formGroup]="formGroup"
          [disabled]="stepDisabled()"
        />
      </ng-template>
    </app-form-array-card>
  </app-card>
</form>

}
